import { Schema, schema } from 'normalizr';
import Device from './types/Device';
import DeviceGroup from './types/DeviceGroup';
import Game from './types/Game';
import ContentOwnership from './types/ContentOwnership';

export default (schema): Schema<any> => {
  const Device: schema.Entity<Device> = new schema.Entity('Device');
  const DeviceGroup: schema.Entity<DeviceGroup> = new schema.Entity(
    'DeviceGroup',
    {
      devices: [Device],
    }
  );
  const Game: schema.Entity<Game> = new schema.Entity('Game', {});
  const ContentOwnership: schema.Entity<ContentOwnership> = new schema.Entity(
    'ContentOwnership',
    {}
  );

  return {
    Game,
    ContentOwnership,
    Device,
    DeviceGroup,
  };
};
